export const botUrl = 'https://t.me/babytrackertma'
export const pageSize = 15
